export default {

    props: [
        'query',
        'filter',
        'letter',
        'filterTaxonomy',
        'checkboxOptions',
        'defaultOption',
        'defaultOptionSelected',
        'tagsOverride'
    ],

    data: () => ({
        string: '',
        selectedFilter: '',
        letterFilter: '',
        keyTaxonomyComponent: 0,
        stringProfile: '',
        valueFilterTaxonomy: null,
        componentId: null,
        filterOnFocus: false,
        checkboxOptionsList: {},
        checkboxOptionsListSelected: {},
        defaultCheckboxOptionsIndex: null
    }),

    beforeMount() {
        this.componentId = this._uid;

        if (this.checkboxOptions !== undefined) {
            this.checkboxOptionsList = this.checkboxOptions;
        }

        if (this.defaultOption !== undefined) {
            this.checkboxOptionsList.unshift(this.defaultOption)
        }

        if (this.defaultOptionSelected === true && this.defaultOption !== undefined) {
            this.checkboxOptionsListSelected[0] = true
        }
    },

    mounted() {
      this.string = this.query;
      this.letterFilter = this.letter;
      this.selectedFilter = this.filter;
      this.valueFilterTaxonomy = this.filterTaxonomy;

        document.getElementById('query-input-search').addEventListener("keyup", ({key}) => {
            if (key === "Enter") {
                this.submitSearch();
            }
        })
    },

    watch: {
        checkboxOptionsListSelected: function (tagList){
            /*let filterList = [];
            Object.keys(tagList).forEach((selected) => {
                let value = this.checkboxOptionsList[selected] === this.defaultOption ? 'all' : this.checkboxOptionsList[selected];
                filterList.push(value);
            });
            this.applyFilterTaxonomy(filterList);
            */
        }
    },

    methods: {
        showOptions: function() {
            this.filterOnFocus = true;
        },
        hideOptions: function(e) {
            this.filterOnFocus = false;
        },
        applyFilterTaxonomy: function(index){
            let selectedtag = this.checkboxOptionsList[index];
            let taxonomyList = selectedtag !== this.defaultOption ? [selectedtag] : [];
            this.checkboxOptionsListSelected = {index: true}; //reset checkbox group, using as radio
            this.valueFilterTaxonomy = taxonomyList;
            this.keyTaxonomyComponent++;
            this.hideOptions();
        },
        clearFilterTaxonomy: function(){
            this.checkboxOptionsListSelected = {0: true}
            this.valueFilterTaxonomy = [];
            this.keyTaxonomyComponent = 0;
            this.hideOptions();
        },
        submitSearch: function(){
            this.letterFilter = '';
            this.keyTaxonomyComponent++;
        },
        filterCheckBoxProfile: function(){
            document.getElementById('search-input-block-' + this.componentId)
                .querySelectorAll('.form-check')
                .forEach((div, index) => {
                    let dataFilter = div.getAttribute('data-filter');
                    if( this.stringProfile === '' || dataFilter.toLowerCase().indexOf(this.stringProfile.toLowerCase()) > -1 ){
                        div.classList.remove('d-none');
                    }else{
                        div.classList.add('d-none');
                    }
                })
        },
        applyFilterLetter: function(l){
            this.string = '';
            this.letterFilter = l;
            this.keyTaxonomyComponent++;
        },
        clearFilter: function (){
            this.string = '';
            this.clearFilterTaxonomy();
            this.submitSearch();
        },
        defaultOptionIsSelected: function () {
            return Object.keys(this.checkboxOptionsListSelected).indexOf(0) !== -1
        }
    }

}
